import * as React from 'react';
import {
  RightMenuPanelContainer,
  ListContainer,
  LiContainer,
  LinkStyle,
} from './rightMenuPanelStyle';
import isExternalUrl, {
  addTrailingSlash,
  isExternalUrlhref,
} from '../../../utils';

const RightMenuPanel = (props) => {
  return (
    <RightMenuPanelContainer>
      <ListContainer>
        {props?.menu?.map((item, index) => {
          return (
            <LiContainer key={index}>
              <LinkStyle
                href={
                  item?.textWithPath?.path
                    ? isExternalUrlhref(item?.textWithPath?.path)
                      ? item?.textWithPath?.path
                      : addTrailingSlash(
                          process.env.GATSBY_DOMAIN_URL +
                            item?.textWithPath?.path
                        )
                    : '/'
                }
                target={
                  isExternalUrl(item?.textWithPath?.path) ? '_blank' : '_self'
                }
              >
                {item?.textWithPath?.text}
              </LinkStyle>
            </LiContainer>
          );
        })}
      </ListContainer>
    </RightMenuPanelContainer>
  );
};

export default RightMenuPanel;
